import { Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'eui-header-user-profile',
    templateUrl: './header-user-profile.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiHeaderUserProfileComponent {

    @HostBinding() class = 'eui-header-user-profile';
    @Input() hasWelcomeLabel = false;
    @Input() avatarUrl: string;
    @Input() welcomeLabel = 'Welcome';
    @Input() impersonateLabel = 'impersonating';
}
